import _ from 'lodash';
import { getRecoil, setRecoil } from 'recoil-nexus';

import state from 'components/state';

const defaultClinicalNote = {
  notes: '',
  subjective: '',
  objective: '',
  present_illness: '',
  other_complaints: '',
  assessment: '',
  plan: '',
  exam: '',
  test: '',
  epn: {
    riskFactors: {
      narrative: ''
    },
    session: {
      narrative: ''
    },
    sessionQuotesAndContents: '',
    activeSymptoms: {
      narrative: ''
    },
    functionalImpairment: {
      narrative: ''
    },
    interventions: {
      narrative: ''
    },
    progress: {
      narrative: ''
    }
  },
  goals: '',
  goals_narrative: '',
  mha: {
    riskAndCoMorbidities: '',
    timeFrames: ''
  },
  hpi: {
    narrative: ''
  },
  ros: {
    narrative: ''
  }
};

const updateClinicalNote = (data) => {
  try {
    const { vertical, form_name: initialFormName, form_type, response } = data;
    const isNotCustomForm = !form_type?.includes('custom_form_narrative');
    let form_name = initialFormName;

    if (form_name === 'progress') {
      form_name = 'epn';
    }
    if (form_name === 'intake') {
      form_name = 'mha';
    }

    if (['soap', 'hp', 'clinical_narrative'].includes(vertical) && isNotCustomForm) {
      if (defaultClinicalNote?.[form_name]?.[form_type]?.['narrative'] !== undefined) {
        setRecoil(state.clinicalNote, (ps) => ({
          ...ps,
          [form_name]: {
            ...ps?.[form_name],
            [form_type]: {
              ...ps?.[form_name]?.[form_type],
              narrative: response
            }
          }
        }));
      } else if (defaultClinicalNote?.[form_name]?.[form_type] !== undefined) {
        setRecoil(state.clinicalNote, (ps) => ({
          ...ps,
          [form_name]: {
            ...ps?.[form_name],
            [form_type]: response
          }
        }));
      } else if (defaultClinicalNote?.[form_type]?.['narrative'] !== undefined) {
        setRecoil(state.clinicalNote, (ps) => ({
          ...ps,
          [form_type]: {
            ...ps?.[form_type],
            narrative: response
          }
        }));
      } else if (defaultClinicalNote?.[form_type] !== undefined) {
        setRecoil(state.clinicalNote, (ps) => ({
          ...ps,
          [form_type]: response
        }));
      }
    }

    const newAiClinicalNoteState = getRecoil(state.intelligenceAiState);
    if (newAiClinicalNoteState?.timeoutTimeout)
      clearTimeout(newAiClinicalNoteState?.timeoutTimeout);
    setRecoil(state.intelligenceAiState, (ps) => ({
      ...ps,
      loading: !!!data?.done,
      response: data?.response,
      path: `${vertical}.${data?.form_name}.${data?.form_type}`
    }));
  } catch (e) {
    console.log(e);
  }
};

export default updateClinicalNote;
